<template>
  <div class="white__bg">
    <div class="footer__component">
      <div class="social__icons">
        <ul>
          <li>
            <a target="_blank" href="https://www.linkedin.com/in/tejaspagooah/">
              <svg
                version="1.1"
                id="LinkedIn_alt"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 535.6 512"
                style="enable-background: new 0 0 535.6 512"
                xml:space="preserve"
              >
                <path
                  class="st0"
                  d="M6.8,166.5h114.8V512H6.8C6.8,512,6.8,166.5,6.8,166.5z M64.9,0C25.6,0,0,25.8,0,59.6
								c0,33.2,24.9,59.7,63.5,59.7h0.8c40,0,64.9-26.5,64.9-59.7C128.4,25.8,104.2,0,64.9,0z M403.4,158.4c-61,0-88.2,33.5-103.4,57v-48.8
								H185.2c1.5,32.4,0,345.5,0,345.5h114.8V318.9c0-10.3,0.8-20.7,3.8-28.1c8.3-20.7,27.2-42,58.9-42c41.6,0,58.1,31.8,58.1,78v184.8
								h114.8V313.8C535.6,207.7,479,158.4,403.4,158.4z"
                />
              </svg>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://twitter.com/nirvanpagooah">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 629.2 512"
                style="enable-background: new 0 0 629.2 512"
                xml:space="preserve"
              >
                <path
                  class="st0"
                  d="M629.2,60.7c-23.2,10.3-48,17.2-74.1,20.4c26.7-16,47.2-41.3,56.8-71.5c-24.9,14.8-52.5,25.6-82,31.3
								C506.3,15.7,472.7,0,435.6,0c-71.3,0-129.1,57.9-129.1,129.2c0,10.1,1.1,20,3.3,29.5c-107.3-5.3-202.5-56.8-266.1-135.1
								C32.7,42.7,26.3,64.9,26.3,88.5c0,44.8,22.8,84.4,57.5,107.6c-21.2-0.5-41.2-6.4-58.5-16.1c0,0.5,0,1.1,0,1.6
								c0,62.7,44.5,114.8,103.6,126.7c-10.8,2.9-22.3,4.5-34,4.5c-8.3,0-16.4-0.8-24.3-2.4c16.4,51.3,64.1,88.7,120.7,89.7
								c-44.1,34.7-99.9,55.3-160.4,55.3c-10.4,0-20.7-0.7-30.8-1.9C57.1,490.7,124.9,512,197.7,512c237.6,0,367.5-196.9,367.5-367.7
								c0-5.6-0.1-11.2-0.4-16.7C590,109.3,611.9,86.5,629.2,60.7z"
                />
              </svg>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.instagram.com/nirvanpagooah/">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns:serif="http://www.serif.com/"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 300 300"
                style="enable-background: new 0 0 300 300"
                xml:space="preserve"
              >
                <g transform="matrix(1.01619,0,0,1.01619,44,43.8384)">
                  <path
                    class="st0"
                    d="M104.3-43.1c-40.1,0-45.1,0.1-60.8,0.9C27.8-41.5,17-39,7.7-35.4c-9.7,3.7-17.9,8.8-26.1,17.1
									s-13.2,16.4-17,26.1c-3.6,9.4-6.1,20.1-6.9,35.8c-0.7,15.7-0.9,20.7-0.9,60.8s0.1,45.1,0.9,60.8c0.7,15.7,3.2,26.5,6.9,35.8
									c3.7,9.7,8.8,17.9,17,26.1c8.2,8.2,16.4,13.2,26.1,17c9.4,3.6,20.1,6.1,35.8,6.9c15.7,0.7,20.7,0.9,60.8,0.9s45.1-0.1,60.8-0.9
									c15.7-0.7,26.5-3.2,35.8-6.9c9.7-3.7,17.9-8.8,26.1-17c8.2-8.2,13.2-16.4,17-26.1c3.6-9.4,6.1-20.1,6.9-35.8
									c0.7-15.7,0.9-20.7,0.9-60.8s-0.1-45.1-0.9-60.8c-0.7-15.7-3.2-26.5-6.9-35.8c-3.7-9.7-8.8-17.9-17-26.1s-16.4-13.2-26.1-17
									c-9.4-3.6-20.1-6.1-35.8-6.9C149.4-42.9,144.4-43.1,104.3-43.1z M104.3-16.5c39.4,0,44,0.1,59.6,0.8c14.4,0.7,22.3,3,27.4,5
									c6.9,2.7,11.8,5.9,17,11s8.3,10.1,11,17c2,5.2,4.5,13,5,27.4c0.7,15.6,0.8,20.3,0.8,59.6s-0.1,44-0.8,59.6c-0.7,14.4-3,22.3-5,27.4
									c-2.7,6.9-5.9,11.8-11,17c-5.2,5.2-10.1,8.3-17,11c-5.2,2-13,4.5-27.4,5c-15.6,0.7-20.3,0.8-59.6,0.8s-44-0.1-59.6-0.8
									c-14.4-0.7-22.3-3-27.4-5c-6.9-2.7-11.8-5.9-17-11c-5.2-5.2-8.3-10.1-11-17c-2-5.2-4.5-13-5-27.4c-0.7-15.5-0.9-20.1-0.9-59.5
									s0.1-44,0.8-59.6c0.7-14.4,3-22.3,5-27.4c2.7-6.9,5.9-11.8,11-17s10.1-8.3,17-11c5.2-2,13-4.5,27.4-5
									C60.3-16.4,64.9-16.5,104.3-16.5z"
                  />
                  <path
                    class="st0"
                    d="M104.3,153.7c-27.2,0-49.2-22-49.2-49.2s22-49.2,49.2-49.2s49.2,22,49.2,49.2S131.5,153.7,104.3,153.7z
									M104.3,28.7c-41.8,0-75.8,34-75.8,75.8s34,75.8,75.8,75.8s75.8-34,75.8-75.8C180.1,62.5,146.1,28.7,104.3,28.7z"
                  />
                  <path
                    class="st0"
                    d="M200.8,25.6c0,9.7-8,17.7-17.7,17.7s-17.7-8-17.7-17.7s8-17.7,17.7-17.7C192.9,7.9,200.8,15.9,200.8,25.6z"
                  />
                </g>
              </svg>
            </a>
          </li>

          <li>
            <a target="_blank" href="https://github.com/nirvanpagooah">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 512 512"
                style="enable-background: new 0 0 512 512"
                xml:space="preserve"
              >
                <g>
                  <path
                    class="st0"
                    d="M256,0C114.6,0,0,117.5,0,262.5c0,116,73.4,214.3,175.1,249c12.8,2.4,17.5-5.7,17.5-12.7
										c0-6.3-0.2-22.7-0.3-44.7C121,470.1,105.9,419,105.9,419c-11.7-30.3-28.5-38.4-28.5-38.4c-23.2-16.3,1.7-16,1.7-16
										c25.7,1.8,39.2,27.1,39.2,27.1c22.9,40.1,59.9,28.6,74.5,21.8c2.3-16.9,8.9-28.6,16.2-35.1c-56.8-6.6-116.6-29.1-116.6-129.7
										c0-28.7,9.9-52.1,26.3-70.4c-2.6-6.6-11.4-33.4,2.5-69.5c0,0,21.5-7.1,70.4,26.9c20.5-5.8,42.3-8.7,64.1-8.8
										c21.7,0.1,43.7,3,64.1,8.8c48.9-33.9,70.3-26.9,70.3-26.9c13.9,36.1,5.1,62.9,2.5,69.5c16.3,18.4,26.3,41.8,26.3,70.4
										c0,100.8-59.9,123-116.9,129.5c9.1,8.1,17.4,24.1,17.4,48.6c0,35.1-0.3,63.4-0.3,72c0,7,4.6,15.2,17.6,12.6
										C438.8,476.7,512,378.4,512,262.5C512,117.5,397.4,0,256,0z"
                  />
                </g>
              </svg>
            </a>
          </li>
        </ul>
      </div>

      <div class="copyright__information">
        <div class="left__column">
          <p>&copy; Nirvan Tejas Pagooah</p>
        </div>
        <div class="right__column">
          <p>
            Crafted with
            <span class="love"
              ><img src="@/assets/icons/love.svg" alt=""
            /></span>
            in Mauritius
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.white__bg {
  background: var(--color-footer-bg);
}

.footer__component {
  max-width: 1400px;
  margin: 0 auto;
  padding: calc(var(--gutter) * 3) 15px;
  text-align: left;
  color: var(--color-footer-text);

  .social__icons {
    display: flex;
    justify-content: center;

    ul,
    li {
      margin: 0;
      padding: 0;
      list-style-type: none;
      display: flex;

      a {
        svg {
          height: 25px;
          transition: all 0.1s ease-in-out;

          .st0 {
            fill: var(--color-blue);
          }
        }
        &:hover {
          svg {
            transform: scale(1.2);
          }
        }
      }
    }

    li {
      margin-right: 40px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .copyright__information {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid var(--color-footer-border);

    .left__column,
    .right__column {
      p {
        font-family: var(--font-noto);
        font-size: 20px;
        letter-spacing: -0.5px;
      }
    }

    .right__column {
      text-align: right;

      .love {
        position: relative;
        top: 3px;

        img {
          height: 20px;
          transition: all 0.1s ease-in-out;

          &:hover {
            transform: scale(1.3);
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .footer__component {
    .copyright__information {
      display: grid;
      grid-template-columns: 1fr;

      .left__column,
      .right__column {
        p {
          font-size: 20px;
          text-align: center;
        }
      }

      .left__column {
        p {
          margin: 0;
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .footer__component {
    .copyright__information {
      .left__column,
      .right__column {
        p {
          font-size: 17px;
          text-align: center;
        }
      }

      .left__column {
        p {
          margin: 0;
        }
      }
    }
  }
}
</style>
